import { List, GalleryWithProgress } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import useTranslation from '@Queries/useTranslation';
import RibbleCard from './elems/RibbleCard';
import styles from './RibbleComposition.module.css';

import type { ModuleProductData } from '@Types/ModuleProduct';
import type { FC } from 'react';

interface RibbleCompositionProps {
  className?: string;
  modules: ModuleProductData[];
}

const RibbleComposition: FC<RibbleCompositionProps> = (props) => {
  const { modules, ...restProps } = props;
  const { isMobileM } = useMedias();
  const { t } = useTranslation();

  return (
    <div {...restProps} data-testid='ribble-composition'>
      <div className={styles.title}>{t('ribble.composition.title')}</div>

      {isMobileM ? (
        <div className={styles.container}>
          <GalleryWithProgress
            cnGallery={styles.gallery}
            cnLayer={styles.layer}
            cnTrack={styles.track}
            emptyTrack
          >
            {modules.map((module) => (
              <div key={module.id} className={styles.item}>
                <RibbleCard className={styles.card} module={module} />
              </div>
            ))}
          </GalleryWithProgress>
        </div>
      ) : (
        <List
          className={styles.list}
          items={modules}
          renderChild={(module: ModuleProductData) => <RibbleCard module={module} />}
        />
      )}
    </div>
  );
};

export default RibbleComposition;
